import React from "react";
import { Link } from "react-router-dom";
import { facebookLink, instagramLink } from "../constants";
import { AppLauncher } from "@capacitor/app-launcher";

const Footer = () => {
  const checkCanOpenUrl = async (url) => {
    const { value } = await AppLauncher.canOpenUrl({ url });
    return value;
  };

  const openUrl = async (url) => {
    if (checkCanOpenUrl()) {
      await AppLauncher.openUrl({
        url,
      });
    } else {
      window.open(url);
    }
  };

  const links = [
    {
      name: "Home",
      url: "/",
    },
    {
      name: "About",
      url: "/about-us",
    },
    {
      name: "Contact",
      url: "/#contact",
    },
  ];
  return (
    <div
      className={
        " w-full bg-navyBlue text-white shadow-md z-50 pt-13.5 md:pt-25 md:!pb-7 lg:px-16 !px-4 md:!px-10 2xl:!px-48"
      }
    >
      <div className="max-w-custom mx-auto">
        <div className="grid md:grid-cols-6   md:!gap-x-32 lg:!gap-x-29 ">
          <div className="text-5.5 md:text-5xl leading-6.5 md:leading-12 font-halyard font-normal md:col-span-3 ">
            We facilitate access to Healthcare Services for your loved ones.
          </div>
          <div className="md:justify-center md:items-center grid  gap-y-5 self-start md:col-span-1 ">
            <div className="text-md font-normal leading-7 font-dm-sans !pt-5 md:!pt-1">
              Address
            </div>
            <div className="font-dm-sans font-normal leading-7 text-md text-midWhite">
              14182 Gunhill Avenue, Borrowdale, Harare, Zimbabwe
            </div>
            <div className="flex space-x-5 justify-start md:!justify-start md:!items-start">
              <button
                className="h-10  min-w-10 border-midWhite rounded-full border-[0.5px] p-1 cursor-pointer hover:border-primary-blue"
                // href={facebookLink}
                onClick={() => openUrl(facebookLink)}
                // className="h-10 min-w-10 bg-lightRed rounded-full flex justify-center items-center"
              >
                <img
                  src="/health/images/facebook.svg"
                  className="size-6 relative left-1 bottom-1"
                  alt="facebook icon"
                />
              </button>
              <button
                className="h-10 border-midWhite rounded-full w-10 p-2.5 border-[0.5px] cursor-pointer hover:border-primary-blue"
                // href={instagramLink}
                onClick={() => openUrl(instagramLink)}
              >
                <img src="/health/images/instagram.svg" alt="instagram icon" />
              </button>
            </div>
          </div>
          <div className="justify-center items-center grid gap-y-1 md:gap-y-5 md:col-span-2 !pt-5 md:!pt-0 whitespace-break-spaces">
            <div className="text-md font-normal leading-7 font-dm-sans ">
              Contact Us
            </div>
            <div className="font-dm-sans font-normal leading-7 text-md text-midWhite">
              info@totalurgenthealth.comfort
            </div>
            <div className="font-dm-sans font-normal leading-7 text-md text-midWhite">
              Whatsapp (263) 781 428-214 USA - (312) 932-8370 UK - +44 (20)
              37442394 Australia - +61(8)61043366 Canada - (902) 332-1282
            </div>
          </div>
        </div>

        <hr className="text-midWhite border-opacity-30 mt-20" />
        <div className="flex flex-col md:flex-row justify-center items-center md:justify-between pt-4 ">
          <div className="space-x-7 text-lg font-normal text-midWhite flex">
            {links.map(({ name, url }) => (
              <Link
                key={name}
                className="group bg-transparent leading-6.5 transition duration-300 font-halyard capitalize font-normal text-[17px]/6 self-end text-md text-white tracking-normal"
                to={url}
              >
                {name}
                <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-0.5 bg-white"></span>
              </Link>
            ))}
          </div>
          <div className="text-md font-normal text-midWhite text-center leading-7 font-dm-sans !pt-3 md:!pt-0 !mb-5">
            Total Urgent Health © 2024. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
